export class AIMessage{
    AIMessageID!: number;
    PortalId!: number;
    UserId!: number;
    UserName!: string;
    RoleId!:number;
    QuestionId!:number;
    QuestionTypeId!:number;
    ConversationId!:string;
    Question!: string;
    RefinedQuestion!:string;
    RootQuestion!:string;
    Answer!:string;
    CreatedDate!: Date | string;
}
export class RootQuestionMetric{
    Order!:number;
    RootQuestion!:string;
    Count!:number;
    AIMessages:AIMessage[] = [];
}
export class AIFeedbackMetric{
    FeedbackStatus!:string;
    FeedbackCount!:number;
    Percentage!:number;
    SliceColor!:string;
}
export class AIQuestionCountMetric{
    Date!: Date; 
    Count!: number
    LineColor!:string;
}
export class AIPredefinedQuestion{
    WelcomeText!: string;
    PredefinedQuestions: string[] = [];
}
